<template>
  <div>
    <v-card>
      <v-card-title>Configuração</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="3">
            <v-file-input v-model="certificado" label="Upload Certificado"></v-file-input>
            <v-btn color="primary" @click="uploadCertificado" :disabled="!certificado"> Enviar Certificado </v-btn>
          </v-col>

          <v-col cols="12" sm="3">
            <span>Senha do Certificado:</span>
            <input type="password" v-model="senha" class="form-control" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import LojaService from "@/infra/service/LojaService";
import ToastService from "@/infra/service/ToastService";

export default {
  data() {
    return {
      certificado: null,
      senha: "",
    };
  },
  computed: {
    lojaId: {
      get() {
        return this.$store.state.loja.loja.codigo;
      },
    },
  },

  methods: {
    async uploadCertificado() {
      await LojaService.uploadCertificado(this.certificado, this.senha, this.lojaId);
      ToastService.showSuccess("Certificado atualizado com sucesso !");
    },
  },
};
</script>
